module.exports = __webpack_public_path__ + "img/20240909123424990nb0.f8cf6498.jpg";